import React from 'react';
import { Icons } from '../icons.jsx';

// =============================================
// MORE DRAWER COMPONENT
// =============================================

export function MoreDrawer({ showMoreDrawer, setShowMoreDrawer, setActiveSection, setActiveModule }) {
    if (!showMoreDrawer) return null;

    return (
        <>
            <div className="more-drawer-overlay" onClick={() => setShowMoreDrawer(false)} />
            <div className="more-drawer">
                <div className="more-drawer-handle" />
                <div className="more-drawer-title">Quick Access</div>

                <button className="more-drawer-item" onClick={() => { setActiveSection('fi-advisor'); setShowMoreDrawer(false); }}>
                    <div className="more-drawer-item-icon" style={{ background: 'rgba(167,139,250,0.14)' }}>
                        <span className="nav-icon" style={{ color: '#A78BFA' }}>{Icons.fiAdvisor}</span>
                    </div>
                    <div>
                        <div className="more-drawer-item-label">FI Advisor</div>
                        <div className="more-drawer-item-sub">AI-powered financial guidance</div>
                    </div>
                    <span className="more-drawer-item-arrow">›</span>
                </button>

                <button className="more-drawer-item" onClick={() => { setActiveSection('investments'); setActiveModule('inv-portfolio'); setShowMoreDrawer(false); }}>
                    <div className="more-drawer-item-icon" style={{ background: 'rgba(129,140,248,0.14)' }}>
                        <span className="nav-icon" style={{ color: '#818cf8' }}>{Icons.investments}</span>
                    </div>
                    <div>
                        <div className="more-drawer-item-label">Investments</div>
                        <div className="more-drawer-item-sub">Portfolio · Cash · Money Market</div>
                    </div>
                    <span className="more-drawer-item-arrow">›</span>
                </button>

                <button className="more-drawer-item" onClick={() => { setActiveSection('fixed-assets'); setActiveModule('fa-overview'); setShowMoreDrawer(false); }}>
                    <div className="more-drawer-item-icon" style={{ background: 'rgba(251,191,36,0.12)' }}>
                        <span className="nav-icon" style={{ color: '#fbbf24' }}>{Icons.fixedAssets}</span>
                    </div>
                    <div>
                        <div className="more-drawer-item-label">Property</div>
                        <div className="more-drawer-item-sub">Land · Houses · Fixed Assets</div>
                    </div>
                    <span className="more-drawer-item-arrow">›</span>
                </button>

                <button className="more-drawer-item" onClick={() => { setActiveSection('settings'); setShowMoreDrawer(false); }}>
                    <div className="more-drawer-item-icon" style={{ background: 'rgba(148,163,184,0.08)' }}>
                        <span className="nav-icon" style={{ color: '#94A3B8' }}>{Icons.settings}</span>
                    </div>
                    <div>
                        <div className="more-drawer-item-label">Settings</div>
                        <div className="more-drawer-item-sub">Rates · Currency · Sync · Data</div>
                    </div>
                    <span className="more-drawer-item-arrow">›</span>
                </button>

                <button className="more-drawer-item" onClick={() => { setActiveSection('milestones'); setShowMoreDrawer(false); }}>
                    <div className="more-drawer-item-icon" style={{ background: 'rgba(251,146,60,0.14)' }}>
                        <span className="nav-icon" style={{ color: '#fb923c', fontSize: '18px' }}>🏆</span>
                    </div>
                    <div>
                        <div className="more-drawer-item-label">Journey</div>
                        <div className="more-drawer-item-sub">Financial milestones &amp; achievements</div>
                    </div>
                    <span className="more-drawer-item-arrow">›</span>
                </button>

                <button className="more-drawer-dismiss" onClick={() => setShowMoreDrawer(false)}>Dismiss</button>
            </div>
        </>
    );
}
